/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Parameters that override default values of srt conversion. max_line_length: sets maximum count of characters per subtitle line including white space. max_lines: sets maximum count of lines in a subtitle section.
 * @export
 * @interface OutputConfigSrtOverrides
 */
export interface OutputConfigSrtOverrides {
  /**
   *
   * @type {number}
   * @memberof OutputConfigSrtOverrides
   */
  max_line_length?: number;
  /**
   *
   * @type {number}
   * @memberof OutputConfigSrtOverrides
   */
  max_lines?: number;
}
